import { ModelBaseModel } from '../model-base/model-base.model'

import { cloneDeep } from 'lodash'
import { CONST } from '../../const/const'
import { IRegistrationByDayInterface } from './registrationByDay.interface'

// Constants
const REGISTRATION_BY_DAY_COLLECTION = CONST.DATA.FIRESTORE.LATEST.COLLECTIONS.REGISTRATION_BY_DAY

export class RegistrationByDayModel extends ModelBaseModel<IRegistrationByDayInterface> {
  // Properties
  public v: IRegistrationByDayInterface['v']
  public id: IRegistrationByDayInterface['id']

  public userId: IRegistrationByDayInterface['userId']
  public userName: IRegistrationByDayInterface['userName']

  public eventId: IRegistrationByDayInterface['eventId']
  public eventName: IRegistrationByDayInterface['eventName']

  public horseId: IRegistrationByDayInterface['horseId']
  public horseName: IRegistrationByDayInterface['horseName']
  public horsesSelected: IRegistrationByDayInterface['horsesSelected']
  public horseProfilePicture: IRegistrationByDayInterface['horseProfilePicture']

  public backNumber: IRegistrationByDayInterface['backNumber']

  public refundId: IRegistrationByDayInterface['refundId']
  public refundDocId: IRegistrationByDayInterface['refundDocId']
  public refundAmountAdded: IRegistrationByDayInterface['refundAmountAdded']
  public refundStatus: IRegistrationByDayInterface['refundStatus']
  public amountRefunded: IRegistrationByDayInterface['amountRefunded']

  public paymentStatus: IRegistrationByDayInterface['paymentStatus']
  public paymentType: IRegistrationByDayInterface['paymentType']
  public checkNumber: IRegistrationByDayInterface['checkNumber']
  public checkMemo: IRegistrationByDayInterface['checkMemo']
  public paidDate: IRegistrationByDayInterface['paidDate']
  public cardNo: IRegistrationByDayInterface['cardNo']
  public invoiceId: IRegistrationByDayInterface['invoiceId']
  public invoiceUrl: IRegistrationByDayInterface['invoiceUrl']
  public isScratched: IRegistrationByDayInterface['isScratched']
  public amountScratched: IRegistrationByDayInterface['amountScratched']
  public scratchedDate: IRegistrationByDayInterface['scratchedDate']

  public recipientId: IRegistrationByDayInterface['recipientId']
  public recipientName: IRegistrationByDayInterface['recipientName']
  public recipientProfilePicture: IRegistrationByDayInterface['recipientProfilePicture']

  public riderId: IRegistrationByDayInterface['riderId']
  public riderName: IRegistrationByDayInterface['riderName']
  public riderDob: IRegistrationByDayInterface['riderDob']
  public riderEmail: IRegistrationByDayInterface['riderEmail']
  public riderNameNGram: IRegistrationByDayInterface['riderNameNGram']
  public riderProfilePicture: IRegistrationByDayInterface['riderProfilePicture']
  public riderCountry: IRegistrationByDayInterface['riderCountry']

  public registrationDocId: IRegistrationByDayInterface['registrationDocId']
  public registrationPrice: IRegistrationByDayInterface['registrationPrice']
  public includeSalesTax: IRegistrationByDayInterface['includeSalesTax']
  public registrationByDayName: IRegistrationByDayInterface['registrationByDayName']

  public isQualify: IRegistrationByDayInterface['isQualify']
  public qualifyFee: IRegistrationByDayInterface['qualifyFee']
  public qualifyFeeName: IRegistrationByDayInterface['qualifyFeeName']

  public order: IRegistrationByDayInterface['order']
  public orderOfGoScratched: IRegistrationByDayInterface['orderOfGoScratched']
  public score: IRegistrationByDayInterface['score']
  public breakTime: IRegistrationByDayInterface['breakTime']
  public divisionUniqId: IRegistrationByDayInterface['divisionUniqId']
  public divisionUuid: IRegistrationByDayInterface['divisionUuid']
  public isDivision: IRegistrationByDayInterface['isDivision']
  public uuid: IRegistrationByDayInterface['uuid']
  public uniqId: IRegistrationByDayInterface['uniqId']

  public rideTime: IRegistrationByDayInterface['rideTime']
  public isOutOfTurn: IRegistrationByDayInterface['isOutOfTurn']

  public created: IRegistrationByDayInterface['created']
  public modified: IRegistrationByDayInterface['modified']

  // %%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%%
  /**
   * @param obj `IRegistrationByDayInterface`
   */
  public constructor(obj?: IRegistrationByDayInterface) {
    super()

    this.v = obj?.v ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.V.VALUES.DEFAULT
    this.id = obj?.id ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.ID.VALUES.DEFAULT
    this.userId = obj?.userId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.USER_ID.VALUES.DEFAULT
    this.userName = obj?.userName ?? null
    this.eventId = obj?.eventId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.EVENT_ID.VALUES.DEFAULT
    this.horseId = obj?.horseId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.HORSE_ID.VALUES.DEFAULT
    this.refundId = obj?.refundId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.REFUND_ID.VALUES.DEFAULT
    this.score = obj?.score ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.SCORE.VALUES.DEFAULT
    this.order = obj?.order ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.ORDER.VALUES.DEFAULT
    this.orderOfGoScratched =
      obj?.orderOfGoScratched ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.ORDER_OF_GO_SCRATCHED.VALUES.DEFAULT
    this.eventName =
      obj?.eventName ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.EVENT_NAME.VALUES.DEFAULT
    this.backNumber =
      obj?.backNumber ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.BACK_NUMBER.VALUES.DEFAULT
    this.horseName =
      obj?.horseName ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.HORSE_NAME.VALUES.DEFAULT
    this.horsesSelected = obj?.horsesSelected ?? []
    this.refundDocId =
      obj?.refundDocId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.REFUND_DOC_ID.VALUES.DEFAULT
    this.invoiceId =
      obj?.invoiceId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.INVOICE_ID.VALUES.DEFAULT
    this.invoiceUrl =
      obj?.invoiceUrl ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.INVOICE_URL.VALUES.DEFAULT
    this.refundAmountAdded =
      obj?.refundAmountAdded ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.REFUND_AMOUNT_ADDED.VALUES.DEFAULT
    this.isScratched =
      obj?.isScratched ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.IS_SCRATCHED.VALUES.DEFAULT
    this.recipientId =
      obj?.recipientId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RECIPIENT_ID.VALUES.DEFAULT
    this.riderId = obj?.riderId ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_ID.VALUES.DEFAULT
    this.refundStatus =
      obj?.refundStatus ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.REFUND_STATUS.VALUES.DEFAULT
    this.paymentStatus =
      obj?.paymentStatus ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.PAYMENT_STATUS.VALUES.DEFAULT
    this.paymentType =
      obj?.paymentType ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.PAYMENT_TYPE.VALUES.DEFAULT
    this.checkNumber =
      obj?.checkNumber ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.CHECK_NUMBER.VALUES.DEFAULT
    this.checkMemo =
      obj?.checkMemo ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.CHECK_MEMO.VALUES.DEFAULT
    this.paidDate = obj?.paidDate ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.PAID_DATE.VALUES.DEFAULT
    this.cardNo = obj?.cardNo ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.CARD_NO.VALUES.DEFAULT
    this.recipientName =
      obj?.recipientName ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RECIPIENT_NAME.VALUES.DEFAULT
    this.amountRefunded =
      obj?.amountRefunded ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.AMOUNT_REFUNDED.VALUES.DEFAULT
    this.riderEmail =
      obj?.riderEmail ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_EMAIL_ID.VALUES.DEFAULT
    this.amountScratched =
      obj?.amountScratched ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.AMOUNT_REFUNDED.VALUES.DEFAULT
    this.scratchedDate =
      obj?.scratchedDate ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.SCRATCHED_DATE.VALUES.DEFAULT
    this.riderName =
      obj?.riderName ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_NAME.VALUES.DEFAULT
    this.riderDob = obj?.riderDob ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_DOB.VALUES.DEFAULT
    this.registrationDocId =
      obj?.registrationDocId ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.REGISTRATION_DOC_ID.VALUES.DEFAULT
    this.registrationPrice =
      obj?.registrationPrice ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.REGISTRATION_PRICE.VALUES.DEFAULT
    this.includeSalesTax =
      obj?.includeSalesTax ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.INCLUDE_SALES_TAX.VALUES.DEFAULT
    this.qualifyFee =
      obj?.qualifyFee ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.QUALIFY_FEE.VALUES.DEFAULT
    this.qualifyFeeName =
      obj?.qualifyFeeName ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.QUALIFY_FEE_NAME.VALUES.DEFAULT
    this.breakTime =
      obj?.breakTime ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.BREAK_TIME.VALUES.DEFAULT
    this.isQualify =
      obj?.isQualify ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.IS_QUALIFY.VALUES.DEFAULT
    this.registrationByDayName =
      obj?.registrationByDayName ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.REGISTRATION_BY_DAY_NAME.VALUES.DEFAULT
    this.riderNameNGram =
      obj?.riderNameNGram ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_NAME_N_GRAM.VALUES.DEFAULT
    this.riderProfilePicture =
      obj?.riderProfilePicture ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_PROFILE_PICTURE.VALUES.DEFAULT
    this.riderCountry =
      obj?.riderCountry ?? REGISTRATION_BY_DAY_COLLECTION.FIELDS.RIDER_COUNTRY.VALUES.DEFAULT
    this.horseProfilePicture =
      obj?.horseProfilePicture ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.HORSE_PROFILE_PICTURE.VALUES.DEFAULT
    this.recipientProfilePicture =
      obj?.recipientProfilePicture ??
      REGISTRATION_BY_DAY_COLLECTION.FIELDS.RECIPIENT_PROFILE_PICTURE.VALUES.DEFAULT
    this.divisionUniqId = obj?.divisionUniqId ?? null
    this.divisionUuid = obj?.divisionUuid ?? null
    this.isDivision = obj?.isDivision ?? false
    this.uuid = obj?.uuid ?? null
    this.uniqId = obj?.uniqId || null
    this.rideTime = obj?.rideTime ?? null
    this.isOutOfTurn = obj?.isOutOfTurn ?? null

    this.created = this.utcTimestamp({
      key: 'created',
      isTimestamp: true,
      value: obj?.created,
    })

    this.modified = this.utcTimestamp({
      key: 'modified',
      isTimestamp: true,
      changeOnUpdate: true,
      value: obj?.modified,
    })

    this.updateNamesNGramsKeys()
  }

  // Methods
  public updateNamesNGramsKeys() {
    if (!!this.riderName) this.riderNameNGram = this._calculateNGrams(this.riderName)
  }

  private _calculateNGrams(value: string) {
    let nGrams: string[] = []
    let words = value?.split(' ') ?? []
    let ngram_words = new Set<string>()
    let lowercase_words = words.map((word) => word.toLowerCase())

    lowercase_words.forEach((word) => {
      let word_iterator = cloneDeep(word)

      while (word_iterator.length > 0) {
        ngram_words.add(cloneDeep(word_iterator))
        word_iterator = word_iterator.slice(0, -1)
      }
    })

    ngram_words.forEach((value) => {
      nGrams.push(value)
    })

    return nGrams
  }

  static fromFirestoreDoc(doc: any) {
    return new RegistrationByDayModel({
      id: doc.id,
      ...doc.data(),
    })
  }
}
